// Keep this as it runs before anything else
// We need to define window.dataLayer in order for events to be buffered
// before GTM consent is given. Otherwise these events will be lost...
export default defineNuxtPlugin({
  name: 'gtm-consent-pre',
  enforce: 'pre', // Ensures this executes before vue-gtm spins up
  setup() {
    if (typeof window === "undefined") return
    window.dataLayer = window.dataLayer || []
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments)
    }
    let savedConsent = null
    try {
      const stored = localStorage.getItem("consentMode")
      if (stored) {
        savedConsent = JSON.parse(stored)
      }
    } catch (e) {
      console.error("Failed to parse consent from localStorage", e)
    }

    if (savedConsent) {
      // If user already accepted/denied in the past, use that immediately
      window.gtag('consent', 'default', savedConsent)
    } else {
      // Otherwise, fall back to strict privacy defaults
      window.gtag('consent', 'default', {
        ad_storage: "denied",
        analytics_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        personalization_storage: "denied",
        functionality_storage: "denied",
        security_storage: "denied",
      })
    }
  }
})
